import { Helper } from '../Helper';
export class HandleValueStructuredStorageHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitOp(node, 'SWAP');
        sb.emitOp(node, 'DUP');
        sb.emitSysCall(node, 'Neo.Iterator.Key');
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitHelper(node, options, sb.helpers.deleteCacheStorage);
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'HASKEY');
            },
            whenTrue: () => {
                sb.emitPushBoolean(node, false);
            },
            whenFalse: () => {
                sb.emitSysCall(node, 'Neo.Enumerator.Value');
                sb.emitSysCall(node, 'Neo.Runtime.Deserialize');
                sb.emitOp(node, 'UNPACK');
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'ROT');
                sb.emitHelper(node, options, sb.helpers.handlePrefixKeyStructuredStorage);
                sb.emitPushBoolean(node, true);
            },
        }));
    }
}

//# sourceMappingURL=HandleValueStructuredStorageHelper.js.map
